import React, { useState, useRef, useEffect } from "react";
import {
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBCardFooter,
  MDBBox,
} from "mdbreact";

import { useHistory, useLocation } from "react-router-dom";
import { url } from "api";
import formatTime from "helpers/formatTime";

import "../BrandItemAdmin/BrandItem.scss";
import moment from "moment";
import { eventTrack } from "helpers/ga4Helper";

import { useHttp } from "hooks/useHttp";
import { editBrandPut } from "api/brands/updateBrand";
import { setBrandDisabled } from "api/brands/setBrandDisabled";
import addNotification from "helpers/notify";
import { companyAdminEditBrand } from "actions/company-admin";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../ui-components/loading";

import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import { createFeatureRequest } from "api/featureRequests/createFeatureRequest";
import { setFeatureRequest, updateBrandData } from "actions/user";
import { Modal } from "antd";
import { RequestCard } from "pages/configuration/requestCard";
import { ClockCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import DefaultImage from "assets/images/Default_Brand_Image.png";
import { extractImageFromZip } from "helpers/extractImageFromZip";
import { uploadFileToServer } from "components/uploadFile/uploadFile";

import FULL_BATTERY_IMG from "assets/images/full.jpg";
import THREE_QUARTER_BATTERY_IMG from "assets/images/three-quarter.jpg";
import HALF_BATTERY_IMG from "assets/images/half.jpg";
import ONE_THIRD_BATTERY_IMG from "assets/images/one-third.jpg";
import EMPTY_BATTERY_IMG from "assets/images/empty.jpg";
import { computeFinalPermissions } from 'helpers/finalPermissions';

let numeral = require("numeral");
const BrandItemPersonalArea = (props) => {
  const {
    img,
    name = "",
    favourite = false,
    description = "",
    date,
    _id = "",
    brandSettingsId,
    posts = [],
    ideas = [],
    user,
    zipInfo,              // leave as-is; we guard below
    isParent = false,
    parentBrandID = "",
    brandNumber = "",
    milestone,
    disabled = false,
  } = props.brandItem ?? {};

  const { isAdmin } = props;

  const { idUser } = props;
  const brandItemState = useRef({ img, name, description, _id, brandSettingsId});

  const dispatch = useDispatch();
  const history = useHistory();
  const imageRef = useRef();
  const location = useLocation();
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const usersPermissionRedux = useSelector((s) => s.user.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user.allPermission);
  const FinalPermissions = computeFinalPermissions({
    userInfo: userInfoRedux,
    allPermission: allPermissionRedux,
    companyPermission: companyPermissionRedux,
    userPermission: usersPermissionRedux,
  });
  const featureRequestRedux = useSelector((s) => s.user.featureRequest);
  const brandsRedux = useSelector((s) => s.user.brands);
  const usersRedux = useSelector((s) => s.user.users);
  const milestonesRedux = useSelector((s) => s.user.milestones);

  const [requestType, setRequestType] = useState("");
  const [requestModal, setRequestModal] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [brandPicture, setBrandPicture] = useState(null);
  const [haltLoading, setHaltLoading] = useState(false);

  // Halt / resume this brand. When halted, all processing (schedulers, queues,
  // AI generation, posting, flows) stops for the brand until it's resumed.
  const toggleHalt = async () => {
    setHaltLoading(true);
    try {
      const res = await setBrandDisabled(_id, !disabled);
      if (res && res.success) {
        dispatch(updateBrandData({ ...props.brandItem, disabled: !disabled }));
        addNotification(
          !disabled ? "Brand halted — all processing paused" : "Brand resumed",
          "success"
        );
      } else {
        addNotification((res && res.err) || "Failed to update brand status", "danger");
      }
    } catch (e) {
      addNotification("Failed to update brand status", "danger");
    } finally {
      setHaltLoading(false);
    }
  };

  const changeBrand = (prop, payload) => {
    brandItemState.current = { ...brandItemState.current, [prop]: payload };
  };
  const editBrandForm = new FormData();

  const editBrandField = (field) => {
    editBrandForm.append(field, brandItemState.current[field]);
  };

  const { loading, request: editBrandAPI } = useHttp({
    requestCallback: editBrandPut,
    onLoad: (res) => {
      // const cloneBrandArr = [...brandsRedux];
      // const i = cloneBrandArr.findIndex((x) => x._id === res._id);
      // cloneBrandArr[i] = res;

      addNotification("Brand updated successfully", "success");
      dispatch(updateBrandData(res));
      if (res.img !== props.img) {
        imageRef.current.src = `${res.img}`;
      }
      dispatch(companyAdminEditBrand(res));
    },
    onError: (res) => {
      // addNotification(res.message, "danger");
    },
  });

  const editBrand = () => {
    editBrandField("_id", _id);
    editBrandField("brandSettingsId", brandSettingsId);
    editBrandField("name", name);
    editBrandField("description", description);
    editBrandField("img", img);

    return editBrandAPI({
      id: brandItemState.current._id,
      brandSettingsId: brandItemState.current.brandSettingsId,
      body: editBrandForm,
    });
  };

useEffect(() => {
  let alive = true;
  (async () => {
    if (img?.split(".").pop() === "gz") {
      const extracted = await extractImageFromZip(img);
      const firstUrl = Array.isArray(extracted) ? extracted[0] : extracted;
      if (alive) setBrandPicture(firstUrl || DefaultImage);
    } else {
      if (alive) setBrandPicture(img || DefaultImage);
    }
  })();
  return () => { alive = false; };
}, [img, brandsRedux]);

  const toggleFavorite = (value) => {
    editBrandField("_id", _id);
    return editBrandAPI({
      _id: brandItemState.current._id,
      brandSettingsId: brandItemState.current.brandSettingsId,
      favourite: !value,
    });
  };

  const isIfcBrand = props.brandItem.isIfcBrand;

  const hiddenFileInput = useRef(null);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const requestAccess = async () => {
    try {
      setRequestLoading(true);
      const res = await createFeatureRequest(userInfoRedux?.id, {
        companyId: userInfoRedux.company,
        permission: requestType,
        userId: userInfoRedux.id,
      });
      if (res) {
        setRequestLoading(false);
        dispatch(
          setFeatureRequest(res?.map((feature) => feature?.requestedFeature))
        );
      }
    } catch (e) {
      setRequestLoading(false);
    }
  };

  const handleImageChange = async (file) => {
    const fileUrl = await uploadFileToServer(file);
    editBrandField("_id", _id);
    return editBrandAPI({
      _id: brandItemState.current._id,
      brandSettingsId: brandItemState.current.brandSettingsId,
      img: fileUrl,
    });
  };

  return (
    <MDBCol className={props.className}>
      <MDBCard
        className="h-100"
        style={disabled ? { opacity: 0.55, filter: "grayscale(1)" } : undefined}
        title={disabled ? "This brand is halted — all processing is paused" : undefined}
      >
        <div className={`brand-item-img`}>
          <img
            src={brandPicture}
            alt={`Brand ${name}`}
            ref={imageRef}
            onError={(e) => (e.target.src = DefaultImage)}
            style={{ margin: "auto" }}
          />

          <div className="brand-card-fav cursor-pointer">
            {loading ? (
              <i className="fa fa-spinner small-spinner" />
            ) : (
              <div onClick={() => {
                toggleFavorite(favourite)
                {
                  eventTrack(
                    "Toggle-Fav-Action",
                    "Toggle-Fav",
                    userInfoRedux?.name,
                    "+1",
                    false,
                    "+1"
                  );
                }
              }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                >
                  <g clipPath="url(#clip0_426_6573)">
                    <rect
                      width="18"
                      height="18"
                      transform="translate(0.455078 0.45459)"
                      fill="white"
                    />
                    <path
                      d="M9.45602 14.1496L4.16593 17.1107L5.34743 11.1645L0.896484 7.04844L6.91676 6.33463L9.45602 0.82959L11.9952 6.33463L18.0155 7.04844L13.5646 11.1645L14.7461 17.1107L9.45602 14.1496Z"
                      fill={favourite ? "#FFBF1B" : "#ddd"}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_426_6573">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0.455078 0.45459)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            )}
          </div>
          <span className="brand-item-date">{formatTime(date)}</span>
        </div>
        <MDBCardBody className="p-3 position-relative">
          {/* {loading ? <Loading color="dark" text="Editing..." /> : null} */}
          <MDBBox className="upload-brand-card-img">
            <input
              style={{ display: "none" }}
              type="file"
              name="file_image"
              className="file-input"
              id="input_image"
              required
              accept={".jpeg,.png,.jpg,.png"}
              disabled={loading}
              ref={hiddenFileInput}
              onChange={(e) => {
                handleImageChange(e.target.files[0]);
              }}
            />
            {isAdmin ? (
              <MDBBtn
                size="sm"
                color=""
                onClick={() => { handleClick()
                  {
                    eventTrack(
                      "Upload-Brand-Image-Action",
                      "Upload-Brand-Image",
                      userInfoRedux?.name,
                      "+1",
                      false,
                      "+1"
                    );
                  }
                }}
                disabled={loading}
              >
                {loading ? (
                  <i className="fa fa-spinner small-spinner" />
                ) : (
                  <MDBIcon icon="camera" className="font-size-1" />
                )}
              </MDBBtn>
            ) : null}
          </MDBBox>

          <MDBBox className="font-size-1 text-bid capitalize d-flex align-items-center battery-container battery-card-container">
            {/* Brand completion:{" "} */}
            {Number(
              milestonesRedux?.find((item) => item?._id === milestone)?.value
            ) == 0 ? (
              <img
                src={EMPTY_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                name={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) <= 25 &&
              Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) > 0 ? (
              <img
                src={ONE_THIRD_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                name={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) <= 50 &&
              Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) >= 26 ? (
              <img
                src={HALF_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                name={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) <= 75 &&
              Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) >= 51 ? (
              <img
                src={THREE_QUARTER_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                name={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) <= 100 &&
              Number(
                milestonesRedux?.find((item) => item?._id === milestone)?.value
              ) >= 76 ? (
              <img
                src={FULL_BATTERY_IMG}
                alt="FULL_BATTERY_IMG"
                name={`${
                  milestonesRedux?.find((item) => item?._id === milestone)
                    ?.value
                }${"%"}`}
              />
            ) : null}
          </MDBBox>

          <MDBCardTitle className="mb-1 font-size-2">
            {name}
            {disabled && (
              <span
                style={{
                  marginLeft: 8, fontSize: 11, fontWeight: 700, color: "#fff",
                  background: "#b91c1c", borderRadius: 10, padding: "2px 8px",
                  verticalAlign: "middle",
                }}
              >
                HALTED
              </span>
            )}
          </MDBCardTitle>
          {posts && posts[0] && posts[0].estimation ? (
            <MDBBox className="card-price font-size-2 mb-1 text-bid">
              {numeral(posts[posts.length - 1].estimation).format(
                `${posts[posts.length - 1]?.currencysymb} 0,0.00`
              )}
            </MDBBox>
          ) : null}

<MDBCardText>
  {(description ?? "").length < 30
    ? (description ?? "")
    : `${(description ?? "").slice(0, 29)}...`}
</MDBCardText>
          <MDBBox className="font-size-1 text-bid capitalize">
            Brand Name: {name ? name : "N/A"}
          </MDBBox>
          {zipInfo ? (
            <MDBBox className="">
              <hr />
              <div className="modelDiv">
                <MDBCardTitle className="mb-1 font-size-2">Model</MDBCardTitle>
                {props.brandItem.isIfcBrand ? (
                  <div>
                    <button
                      className="bg-white text-bid border-bid shadow-none text-style-inherit"
                      onClick={props.openUpdateModal}
                    >
                      <small>update </small>
                      <MDBIcon fas icon="upload" />
                    </button>
                  </div>
                ) : null}
              </div>
              {zipInfo ? (
                <MDBBox className="font-size-1 text-bid">
                  Exported by:{" "}
                  {zipInfo?.exportedBy?.name
                    ? `${zipInfo?.exportedBy.name} ${zipInfo?.exportedBy.lastName}`
                    : zipInfo?.exportedBy ?? "N/A"}
                </MDBBox>
              ) : null}

              {zipInfo ? (
                <MDBBox className="font-size-1 text-bid">
                  Date: {moment(zipInfo.date).format("MMM Do YY , h:mm:ss a")}{" "}
                </MDBBox>
              ) : null}

              {/*<MDBBox className="font-weight-light font-size-1 mb-1">Exported by   { zipInfo.exportedBy} </MDBBox>*/}
            </MDBBox>
          ) : null}
        </MDBCardBody>
        <MDBCardFooter className="pl-2 pr-2 pb-2 pt-0">
          <div className="d-flex align-items-center  justify-content-between">
            {idUser === user || { isAdmin } ? (
              <MDBBtn
                color=""
                className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
                onClick={() => {
                  if (
                    FinalPermissions?.includes(
                      ALL_PERMISSIONS.BRAND_EDIT
                    )
                  ) {
                    props.openSettingModal(_id, brandSettingsId);
                  } else {
                    setRequestType(ALL_PERMISSIONS.BRAND_EDIT);
                    setRequestModal(true);
                  }
                  {
                    eventTrack(
                      "Brand-Access-Action",
                      "Brand-Access",
                      userInfoRedux?.name,
                      "+1",
                      false,
                      "+1"
                    );
                  }
                }}
              >
                Settings
              </MDBBtn>
            ) : null}

            <MDBBtn
              color=""
              className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit"
              onClick={() => {
                if (
                  FinalPermissions?.includes(ALL_PERMISSIONS.ASSIGN_BRAND_ADD)
                ) {
                  props.openMembersModal();
                } else {
                  setRequestType(ALL_PERMISSIONS.ASSIGN_BRAND_ADD);
                  setRequestModal(true);
                }
                {
                  eventTrack(
                    "Brand-Members-Action",
                    "Brand-Members",
                    userInfoRedux?.name,
                    "+1",
                    false,
                    "+1"
                  );
                }
              }}
            >
              Members
            </MDBBtn>
          

            {FinalPermissions?.includes(ALL_PERMISSIONS.IDEA_VIEW) ? (
               (
                <MDBBtn
                  color=""
                  className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
                  onClick={() => {
                    if ( _id != "") {
                      history.push(`/personal-area/brands/${_id}/ideas`);
                    }
                    {
                      eventTrack(
                        "View-History-Action",
                        "View-History",
                        name,
                        _id,
                        false,
                        name
                      );
                    }
                  }}
                >
                   Ideas ({ideas?.length ?? 0})
                </MDBBtn>
              )
            ) : (
              <MDBBtn
                color=""
                className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
                onClick={() => {
                  setRequestType(ALL_PERMISSIONS.POST_VIEW);
                  setRequestModal(true);
                }}
              >
                Ideas
              </MDBBtn>
            )}
            {FinalPermissions?.includes(ALL_PERMISSIONS.POST_VIEW) ? (
               (
                <MDBBtn
                  color=""
                  className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
                  onClick={() => {
                    if ( _id != "") {
                      history.push(`/personal-area/brands/${_id}/posts`);
                    }
                    {
                      eventTrack(
                        "View-History-Action",
                        "View-History",
                        name,
                        _id,
                        false,
                        name
                      );
                    }
                  }}
                >
                  Posts ({posts?.length ?? 0})
                </MDBBtn>
              )
            ) : (
              <MDBBtn
                color=""
                className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
                onClick={() => {
                  setRequestType(ALL_PERMISSIONS.POST_VIEW);
                  setRequestModal(true);
                }}
              >
                Posts
              </MDBBtn>
            )}

            {zipInfo?.paths?.length > 0 && (
              <MDBBtn
                color=""
                className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
                onClick={() => {
                  history.push(`/personal-area/brands/model-view/${_id}`);
                  {
                    eventTrack(
                      "View-Model-Action",
                      "View-Model",
                      name,
                      _id,
                      false,
                      name
                    );
                  }
                }}
              >
                Model
              </MDBBtn>
            )}

            {FinalPermissions?.includes(ALL_PERMISSIONS.BRAND_EDIT) ? (
              <MDBBtn
                color=""
                className={`btnFlex text-white shadow-none text-style-inherit ${disabled ? "bg-success border-success" : ""}`}
                style={disabled ? undefined : { background: "#b91c1c", borderColor: "#b91c1c" }}
                disabled={haltLoading}
                title={disabled ? "Resume this brand" : "Halt this brand — stops ALL processing, flows & outputs"}
                onClick={(e) => { e.stopPropagation(); toggleHalt(); }}
              >
                {haltLoading ? (
                  <i className="fa fa-spinner small-spinner" />
                ) : (
                  <>
                    <MDBIcon icon={disabled ? "play" : "ban"} className="mr-1" />
                    {disabled ? "Resume" : "Halt"}
                  </>
                )}
              </MDBBtn>
            ) : null}

            {idUser === user || { isAdmin } ? (
              <button
                color="danger"
                className="bg-white dlt-btnFlex text-bid border-bid shadow-none text-style-inherit"
                onClick={props.openDeleteModal}
              >
                <MDBIcon icon="trash-alt" size="lg" />
              </button>
            ) : null}
          </div>
        </MDBCardFooter>
      </MDBCard>

      <Modal
        name={
          userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
        }
        open={requestModal}
        footer={null}
        onCancel={() => setRequestModal(false)}
      >
        <RequestCard
          status={featureRequestRedux?.includes(requestType)}
          loading={requestLoading}
          icon={
            featureRequestRedux?.includes(requestType) ? (
              <ClockCircleOutlined style={{ color: "black" }} />
            ) : (
              <InfoCircleOutlined style={{ color: "black" }} />
            )
          }
          name={
            featureRequestRedux?.includes(requestType)
              ? `Request Already Sent`
              : `Oops, looks like you need to ${
                  userInfoRedux?.companyAdmin
                    ? `Acquire License`
                    : `Request Access`
                }`
          }
          description={
            featureRequestRedux?.includes(requestType)
              ? `Please reach out to your brand Admin`
              : `Elevate your experience with exclusive futures, early releases, and premium features.`
          }
          buttonText={
            userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
          }
          buttonHandler={() => requestAccess()}
        />
      </Modal>
    </MDBCol>
  );
};

export default BrandItemPersonalArea;
